export interface Environment {
  // AWS S3 + Lambda download URLs
  NX_AS_CONNECTOR_DOWNLOAD_URL: string;
  NX_ELECTRON_CLIENT_DOWNLOAD_URL?: string;

  // backend service base URLs
  NX_CONFIGURATION_SERVICE_BASE_URL: string;
  NX_GEOMETRY_SERVICE_BASE_URL: string;
  NX_MATERIAL_SERVICE_BASE_URL: string;
  NX_PROJECT_SERVICE_BASE_URL: string;
  NX_QA_SERVICE_BASE_URL: string;
  NX_TEMPLATE_SERVICE_BASE_URL: string;
  NX_TRIGGER_SERVICE_BASE_URL: string;
  NX_USER_SERVICE_BASE_URL: string;

  // external imprint URLs
  NX_IMPRINT_DATAPROTECTION_GENERAL_URL?: string;
  NX_IMPRINT_DATAPROTECTION_EMPLOYEES_URL?: string;
  NX_IMPRINT_DATAPROTECTION_BUSINESSPARTNERS_URL?: string;
  NX_IMPRINT_VWAG_URL?: string;

  // auth information (OIDC & Cognito)
  NX_AVENGERS_BASE_URL: string;
  NX_IDENTITY_POOL_ID: string;
  NX_LOGOUT_URL_COGNITO: string;
  NX_LOGOUT_URL_IDP: string | undefined;
  NX_OIDC_AUTHORITY: string;
  NX_OIDC_CLIENT_ID: string;
  NX_OIDC_SCOPES: string;

  // remaining environment information
  NX_AGGRID_LICENSE_KEY: string;
  NX_ENV_NAME: string;
}

declare const environment: Environment;
const exportEnv = environment;
export { exportEnv as environment };
